module.exports = __webpack_public_path__ + "img/partner3.39dc707a.jpg";